module.exports = __webpack_public_path__ + "fonts/nunito-sans-v6-latin-700.d0b6d0f0.woff2";